import { render, staticRenderFns } from "./receiptAndPayment.vue?vue&type=template&id=568d0694&scoped=true"
import script from "./receiptAndPayment.vue?vue&type=script&lang=js"
export * from "./receiptAndPayment.vue?vue&type=script&lang=js"
import style0 from "./receiptAndPayment.vue?vue&type=style&index=0&id=568d0694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d0694",
  null
  
)

export default component.exports